var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabOthersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .b {\n                fill: #2560a0;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12,1c6.07,0,11,4.93,11,11s-4.93,11-11,11S1,18.07,1,12,5.93,1,12,1m0-1C5.37,0,0,5.37,0,12s5.37,12,12,12,12-5.37,12-12S18.63,0,12,0h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.33,14.51c.41,0,.75,.34,.75,.75s-.34,.75-.75,.75-.75-.34-.75-.75,.34-.75,.75-.75m0-.75c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5-.67-1.5-1.5-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.33,14.51c.41,0,.75,.34,.75,.75s-.34,.75-.75,.75-.75-.34-.75-.75,.34-.75,.75-.75m0-.75c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5-.67-1.5-1.5-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.32,14.51c.41,0,.75,.34,.75,.75s-.34,.75-.75,.75-.75-.34-.75-.75,.34-.75,.75-.75m0-.75c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5-.67-1.5-1.5-1.5h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabOthersIcon);
export default __webpack_public_path__ + "static/media/TabOthersIcon.a4b938ccc317813205cf28537ad051e4.svg";
export { ForwardRef as ReactComponent };